import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs';

import { RouteSegment } from '@core/enums/route-segment.enum';
import { selectIsOptimoTenant } from '@core/stores/auth/auth.selectors';

export const optimoTenantCanActivateGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(selectIsOptimoTenant).pipe(
    take(1),
    map((isOptimoTenant) =>
      isOptimoTenant ? true : new RedirectCommand(router.createUrlTree(['/', RouteSegment.Sites]), { replaceUrl: true })
    )
  );
};
